import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiErrorModal } from '@jtnews/jtn-ui';
import { injectStylesMixin, tsStoreMixin } from '@jtnews/shared';

import styles from './bookmark-error-form.styles.scss?module';

const DEFAULT_MESSAGE = 'Вы можете добавить в закладки только 100 материалов';
const DEFAULT_BTN_TEXT = 'Перейти в закладки';

type ModalEvents = {
  onClosed(): void;
};

type ComponentData = {
  message: string;
};

export type ModalParams =
  | {
      message: string;
    }
  | undefined;

export default componentFactoryOf<ModalEvents>()
  .mixin(injectStylesMixin(styles))
  .mixin(tsStoreMixin)
  .create({
    name: 'BookmarkErrorForm',
    props: {
      params: {
        type: Object as () => ModalParams,
        default: undefined
      }
    },
    data(): ComponentData {
      return {
        message: DEFAULT_MESSAGE
      };
    },
    computed: {
      isMobilePhone(): boolean {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      },
      bookmarksUrl(): string {
        const profileUrl = this.store.commonModule.userInfo?.link || '';
        return `${profileUrl}?tab=bookmarks`;
      }
    },
    methods: {
      closeModal() {
        this.$emit('closed');
      }
    },
    render() {
      return (
        <div
          class={[
            styles.bookmarkErrorForm,
            this.isMobilePhone ? styles.bookmarkErrorFormMobile : ''
          ]}
        >
          <JtnUiErrorModal
            isMobile={this.isMobilePhone}
            message={this.message}
            buttonUrl={this.bookmarksUrl}
            buttonText={DEFAULT_BTN_TEXT}
            onCloseModal={() => this.closeModal()}
          />
        </div>
      );
    }
  });
